export enum NotificationEnum {
	ALL,
	JOINING_REQUESTS,
	BOOKING_REQUESTS,
}
export const NotificationStatus: {
	name: string
	value: string
}[] = []

Object.keys(NotificationEnum).forEach((value: string) =>
	isNaN(+value)
		? NotificationStatus.push({
				name: value,
				value: NotificationEnum[value as any],
		  })
		: null
)
